/* ============================================================
   JHKCreate — Shared Scripts
   assets/jhk-scripts.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── CUSTOM CURSOR ── */
  const cur  = document.getElementById('jhk-cursor');
  const ring = document.getElementById('jhk-cursor-ring');
  if (cur && ring) {
    let mx = -200, my = -200, rx = -200, ry = -200;
    document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; });
    (function loop() {
      rx += (mx - rx) * 0.13; ry += (my - ry) * 0.13;
      cur.style.left  = mx + 'px'; cur.style.top  = my + 'px';
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      requestAnimationFrame(loop);
    })();
    document.querySelectorAll('a, button, .jhk-service-card, .jhk-pillar, .jhk-blog-card').forEach(el => {
      el.addEventListener('mouseenter', () => {
        cur.style.width  = '18px'; cur.style.height  = '18px';
        ring.style.width = '54px'; ring.style.height = '54px';
        ring.style.borderColor = 'rgba(0,229,255,.7)';
      });
      el.addEventListener('mouseleave', () => {
        cur.style.width  = '10px'; cur.style.height  = '10px';
        ring.style.width = '36px'; ring.style.height = '36px';
        ring.style.borderColor = 'rgba(0,229,255,.35)';
      });
    });
  }

  /* ── SCROLL REVEAL ── */
  const reveals = document.querySelectorAll('.jhk-reveal');
  if (reveals.length) {
    const ro = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('jhk-visible'); ro.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    reveals.forEach(el => ro.observe(el));
  }

  /* ── PARTICLES (hero canvas) ── */
  const canvas = document.getElementById('jhk-particles');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    let W, H, pts = [];
    function resize() {
      W = canvas.width  = canvas.offsetWidth;
      H = canvas.height = canvas.offsetHeight;
    }
    resize();
    window.addEventListener('resize', () => { resize(); init(); });
    function init() {
      pts = [];
      const n = Math.min(Math.floor(W * H / 8000), 80);
      for (let i = 0; i < n; i++) pts.push({
        x: Math.random() * W, y: Math.random() * H,
        vx: (Math.random() - .5) * .35, vy: (Math.random() - .5) * .35,
        r: Math.random() * 1.1 + .3,
        a: Math.random() * .45 + .1,
        hue: Math.random() < .6 ? 189 : 82
      });
    }
    init();
    function draw() {
      ctx.clearRect(0, 0, W, H);
      for (let i = 0; i < pts.length; i++) {
        const p = pts[i];
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0) p.x = W; if (p.x > W) p.x = 0;
        if (p.y < 0) p.y = H; if (p.y > H) p.y = 0;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `hsla(${p.hue},100%,70%,${p.a})`; ctx.fill();
        for (let j = i + 1; j < pts.length; j++) {
          const q = pts[j], dx = p.x - q.x, dy = p.y - q.y, d = Math.sqrt(dx*dx + dy*dy);
          if (d < 85) {
            ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(q.x, q.y);
            ctx.strokeStyle = `hsla(${p.hue},100%,70%,${(1 - d / 85) * .1})`;
            ctx.lineWidth = .5; ctx.stroke();
          }
        }
      }
      requestAnimationFrame(draw);
    }
    draw();
  }

  /* ── HERO QUALIFIER ── */
  window.jhkSelectChip = function (el) {
    document.querySelectorAll('.jhk-chip').forEach(c => c.classList.remove('active'));
    el.classList.add('active');
    const d = jhkQualifierData[el.dataset.id];
    if (!d) return;
    document.getElementById('jhk-r-tag').textContent   = d.tag;
    document.getElementById('jhk-r-title').textContent  = d.title;
    document.getElementById('jhk-r-body').textContent   = d.body;
    document.getElementById('jhk-r-cta').textContent    = d.cta;
    const wrap = document.getElementById('jhk-result-wrap');
    const card = document.getElementById('jhk-result-card');
    wrap.style.height = '0'; card.style.opacity = '0'; card.style.transform = 'translateY(10px)';
    requestAnimationFrame(() => {
      wrap.style.transition = 'height .38s cubic-bezier(.4,0,.2,1)';
      wrap.style.height = card.scrollHeight + 'px';
      setTimeout(() => {
        card.style.transition = 'opacity .3s ease, transform .3s ease';
        card.style.opacity = '1'; card.style.transform = 'translateY(0)';
        wrap.style.height = 'auto';
      }, 220);
    });
  };

});

/* Qualifier data — referenced by jhk-hero.liquid schema */
const jhkQualifierData = {
  new:      { tag: 'Platform Architecture', title: "Let's build something right from the start.",  body: "We design Shopify storefronts around your business logic, not a template's limitations. Custom themes, bespoke checkout flows, multi-market configuration — built to scale from day one.", cta: 'Tell us about your project' },
  fix:      { tag: 'Strategic Consulting',  title: "We'll find what's holding you back.",           body: "We audit your entire Shopify ecosystem — theme architecture, app stack, checkout flow, and fulfilment logic — and deliver a clear technical roadmap. Not a sales pitch.", cta: 'Book a store audit' },
  integrate:{ tag: 'Custom Features',       title: 'We engineer the invisible infrastructure.',      body: "ERP connections, warehouse syncs, payment gateways, third-party APIs. We build the integrations that run flawlessly behind the scenes so your team stops firefighting.", cta: 'Describe your integration' },
  scale:    { tag: 'Retained Partnership',  title: "We stay. That's the difference.",               body: "Priority support, Shopify version updates, conversion monitoring, and proactive recommendations — because a high-growth store needs a long-term technical partner.", cta: 'Ask about retained plans' },
  consult:  { tag: 'Strategic Consulting',  title: 'An honest conversation costs nothing.',          body: "Tech stack assessments, migration planning, and architecture decisions for brands that have outgrown their current setup. We advise on the calls that compound over years.", cta: 'Start the conversation' }
};

/* ══ CONTACT MODAL ══
   Intercepts any anchor that points to a contact page (or has [data-open-contact])
   and opens an in-page modal with a Shopify contact form instead. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    const modal = document.getElementById('jhk-contact-modal');
    if (!modal) return;

    let lastFocused = null;

    function isContactHref(href) {
      if (!href) return false;
      try {
        const u = new URL(href, window.location.href);
        // Match /pages/contact, /pages/contact-us, or any path containing /contact
        return /\/pages\/contact(\-us)?\/?$/i.test(u.pathname) ||
               /\/contact(\-us)?\/?$/i.test(u.pathname);
      } catch (e) { return false; }
    }

    function openModal() {
      lastFocused = document.activeElement;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('jhk-modal--open');
      document.body.classList.add('jhk-modal-open');
      // Focus the first input after the open transition
      setTimeout(function () {
        const firstInput = modal.querySelector('input, textarea, button');
        if (firstInput) firstInput.focus();
      }, 80);
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('jhk-modal--open');
      document.body.classList.remove('jhk-modal-open');
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    // Intercept clicks on contact-page anchors anywhere in the document
    document.addEventListener('click', function (e) {
      const anchor = e.target.closest('a');
      if (!anchor) return;

      const opensContact = anchor.hasAttribute('data-open-contact') ||
                           isContactHref(anchor.getAttribute('href'));
      if (!opensContact) return;

      // Don't hijack modifier-clicks (cmd/ctrl-click = open in new tab)
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

      e.preventDefault();
      openModal();
    });

    // Close buttons / backdrop
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-jhk-modal-close]')) {
        closeModal();
      }
    });

    // ESC to close
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });

    // If the page loaded with a successful form submission (Shopify reloads
    // with ?contact_posted=true) reopen the modal so the user sees the success.
    if (/[?&]contact_posted=true/.test(window.location.search) ||
        modal.querySelector('.jhk-modal__success')) {
      openModal();
    }
  });
})();
